// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"162718ca8d4ce2390bff","256":"3ef15e634d7b1d489b97","532":"113b5c354649c69fcd2d"}[chunkId] + ".js";
};